export const TEXTS = {
  WEB_PLAYER_START: (time: string) => `Запуск плеера будет доступен с ${time}`,
  FREQUENTLY_SKIPPING: 'Частый пропуск трека может привести к неправильному времени выхода рекламной кампании',
  NEXT_TRACK_PROMO: 'Следующий терек - рекламный. Если вы пропустите текущий трек, то реклама может выйти не вовремя.',
};
